<div class="video-container">
  <iframe width="{{width}}" height="{{height}}" [src]="safeSrc" allowfullscreen></iframe>
</div>